import {createFileRoute} from "@tanstack/react-router";
import {ProfileAccountForm} from "@/components/profile/account/ProfileAccountForm";

export const Route = createFileRoute("/_mainLayout/profile/account/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ProfileAccountForm/>
  );
}
